window.Blimp = window.Blimp || {};

class User extends Backbone.Model {
}

Blimp.User = User;